import PropTypes from 'prop-types'
import { Select, SIZE, TYPE } from 'baseui/select'
import { mergeOverrides, useStyletron } from 'baseui'
import { FloatingLabel, SDSelectOverrides } from './styled-components'
import { t } from 'i18next'

const SDSelect = ({
  label,
  optionsList,
  selectedValue,
  onChangeHandler,
  placeholder = '',
  clearable = false,
  type = TYPE.select,
  disabled = false,
  hasError = false,
  overrides,
  newTranslations,
  translationsPath,
  ...rest
}) => {
  const [css] = useStyletron()
  const options = []
  const selected = []

  if (optionsList) {
    for (const [id, name] of Object.entries(optionsList)) {
      const label = newTranslations ? t(translationsPath + name) : name
      const optionId = newTranslations ? name : id
      const data = { label, id: optionId }

      options.push(data)

      if (optionId === selectedValue) {
        selected.push(data)
      }
    }
  }

  const newOverrides = mergeOverrides(SDSelectOverrides(), overrides)

  return (
    <div className={css({ position: 'relative' })}>
      {label && (
        <FloatingLabel>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </FloatingLabel>
      )}
      <Select
        disabled={disabled}
        error={hasError}
        options={options}
        clearable={clearable}
        value={selected}
        onChange={onChangeHandler}
        placeholder={placeholder}
        type={type}
        maxDropdownHeight='320px'
        labelKey='label'
        valueKey='label'
        size={SIZE.compact}
        overrides={newOverrides}
        {...rest}
      />
    </div>
  )
}

SDSelect.propTypes = {
  label: PropTypes.string,
  optionsList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeHandler: PropTypes.func,
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  overrides: PropTypes.object,
  newTranslations: PropTypes.bool,
  translationsPath: PropTypes.string,
}

export default SDSelect
